var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"flex-initial relative bg-teal-200",attrs:{"id":"navheader"}})}
var staticRenderFns = []

export { render, staticRenderFns }